import { render, staticRenderFns } from "./deflection.vue?vue&type=template&id=3fe33f33&scoped=true&"
import script from "./deflection.vue?vue&type=script&lang=js&"
export * from "./deflection.vue?vue&type=script&lang=js&"
import style0 from "./deflection.vue?vue&type=style&index=0&id=3fe33f33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe33f33",
  null
  
)

export default component.exports